import React from "react";
import DealSection from "../../../DealSection";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function MoreOffers(_ref) {
  var similarOffers = _ref.similarOffers,
    sameBrandOffers = _ref.sameBrandOffers,
    topOffers = _ref.topOffers,
    isRewards = _ref.isRewards,
    isPoints = _ref.isPoints,
    isBundleDeal = _ref.isBundleDeal,
    config = _ref.config,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    cmsClient = _ref.cmsClient,
    winnreAuth = _ref.winnreAuth,
    winnreNoAuth = _ref.winnreNoAuth,
    _ref$isReloyClient = _ref.isReloyClient,
    isReloyClient = _ref$isReloyClient === void 0 ? false : _ref$isReloyClient;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(similarOffers === null || similarOffers === void 0 ? void 0 : similarOffers.length) > 0 && !isReloyClient && /*#__PURE__*/_jsx(DealSection, {
      type: isBundleDeal ? "OTHER DEALS IN THIS BUNDLE" : isRewards ? "SIMILAR REWARDS" : "SIMILAR OFFERS",
      offers: similarOffers === null || similarOffers === void 0 ? void 0 : similarOffers.slice(0, 4),
      isRewards: isRewards,
      isPoints: isPoints,
      config: config,
      redux: redux,
      router: router,
      cmsClient: cmsClient,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth
    }), sameBrandOffers.length > 0 && !isRewards && /*#__PURE__*/_jsx(DealSection, {
      type: "OTHER OFFERS FROM THIS BRAND",
      offers: sameBrandOffers.slice(0, 4),
      isPoints: isPoints,
      className: similarOffers.length > 0 ? "mt-16" : "",
      config: config,
      redux: redux,
      router: router,
      cmsClient: cmsClient,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth
    }), topOffers.length > 0 && !isRewards && /*#__PURE__*/_jsx(DealSection, {
      type: "OFFERS OF THE MONTH",
      offers: topOffers.slice(0, 4),
      isPoints: isPoints,
      className: similarOffers.length > 0 || sameBrandOffers.length > 0 ? "mt-16" : "",
      config: config,
      redux: redux,
      router: router,
      cmsClient: cmsClient,
      winnreAuth: winnreAuth,
      winnreNoAuth: winnreNoAuth
    })]
  });
}
export default MoreOffers;